import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';
import { ImageInfo, ItemCastCharacterRelation, MainItemBasic, MainType } from '@irohalab/mira-sdk-angular';

import { DEFAULT_IMAGE_INFO, imageRatio } from '../utils';

interface CastItem {
  id: string;
  name?: string;
  nameCn?: string;
}

interface ItemWithRelation {
  name?: string;
  nameCn?: string;
  itemId: string | null | undefined;
  relationType: string | undefined;
  coverImage: ImageInfo;
  imageRatio: number;
  castList: CastItem[];
}

@Component({
    selector: 'app-character-list',
    imports: [
    UIResponsiveImageWrapper
],
    templateUrl: './character-list.component.html',
    styleUrl: './character-list.component.less'
})
export class CharacterListComponent implements OnChanges {

  @Input()
  relatedMainItems!: MainItemBasic[];

  @Input()
  relations!: ItemCastCharacterRelation[];

  itemsWithRelation: ItemWithRelation[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.initItemsWithRelation();
  }

  private initItemsWithRelation(): void {
    if (this.relations?.length > 0 && this.relatedMainItems?.length > 0) {
      const charaIdSet = new Set<string>();
      for (const relation of this.relations) {
        if (!relation.relatedCharacterId || charaIdSet.has(relation.relatedCharacterId)) {
          continue;
        }
        charaIdSet.add(relation.relatedCharacterId);
        const chara = this.relatedMainItems.find(chara => chara.id === relation.relatedCharacterId);
        if (chara) {
          let image = chara?.coverImage;
          if (!image) {
            image = DEFAULT_IMAGE_INFO;
          }
          const castIdList = this.relations
            .filter(rel => rel.relatedCharacterId === relation.relatedCharacterId)
            .map(rel => {
              return rel.relatedCastId;
            });
          const itemWithRelation: ItemWithRelation = {
            itemId: chara.id,
            name: chara.name,
            nameCn: chara.nameCn,
            relationType: relation.relationType,
            castList: this.relatedMainItems.filter(item => castIdList.includes(item.id) && item.mainType === MainType.Person)
              .map(item => {
                return {
                  id: item.id,
                  name: item.name,
                  nameCn: item.nameCn,
                }
              }),
            coverImage: image,
            imageRatio: imageRatio(image)
          };

          this.itemsWithRelation.push(itemWithRelation);
        }
      }
    }
  }
}
